import type { TestSession } from '@k-ucap/shared';
import type { SessionRepository } from './RepositoryInterfaces.js';

const sessions: Map<string, TestSession> = new Map();

export class InMemorySessionRepository implements SessionRepository {
  async findAll(): Promise<TestSession[]> {
    return Array.from(sessions.values()).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async findById(id: string): Promise<TestSession | undefined> {
    return sessions.get(id);
  }

  async findByProjectId(projectId: string): Promise<TestSession[]> {
    return Array.from(sessions.values())
      .filter((s) => s.projectId === projectId)
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async findBySimulationTestId(simulationTestId: string): Promise<TestSession[]> {
    return Array.from(sessions.values())
      .filter((s) => s.simulationTestId === simulationTestId)
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async save(session: TestSession): Promise<TestSession> {
    sessions.set(session.id, session);
    return session;
  }

  async delete(id: string): Promise<void> {
    sessions.delete(id);
  }
}

export const createInMemorySessionRepository = (): InMemorySessionRepository => new InMemorySessionRepository();
